// This will remove the overflowy="auto" from the dialog element and allow scroll only within the content
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const dialog = this.element.closest('[data-pc-name="dialog"]')

    if (dialog) {
      const content = dialog.querySelector('[data-pc-section="content"]')
      const tabs = dialog.querySelector('[data-pc-name="tabs"]')
      dialog.style.overflowY = "hidden"
      dialog.classList.add('h-9/10')

      if (content) {
        content.style.paddingBottom = "0"
        content.style.paddingRight = "0"
        content.style.paddingLeft = "0"
        content.style.overflowY = "hidden"
      }

      if (tabs) {
        let tabs_content = tabs.querySelector('[data-pc-section="content"]')
        let panels = tabs.querySelectorAll('[data-pc-name="tabpanel"]')
        let tabs_list = tabs.querySelector('[data-pc-name="tablist"]')

        tabs.style.height = "100%"
        tabs.style.overflow = "hidden"

        tabs_list.style.borderTopLeftRadius = "0";
        tabs_list.style.borderTopRightRadius = "0";

        panels.forEach((panel) => {
          panel.style.overflowY = "auto"
          panel.style.height = "100%"
        })

        tabs_content.style.paddingRight = "0"
        tabs_content.style.paddingLeft = "0"
      }
    }

    // content has padding that's set inside the application.css file
    // for sticky headers:
    // we want the header and actions section to flush all the way to the modal edge
    // the content between the header and actions section will be scrollable


    // for the Ui::PartialTabs vertical (when admin edits a users Account settings inside a modal)


    // only modals with no parent scroll will have border bottom
    const headerActionsContainer = document.querySelector('[data-pc-section="headeractions"]')
    if (headerActionsContainer) {
      headerActionsContainer.classList.add('border-b', 'border-gray-200')
    }
  }
}
